module.exports = __webpack_public_path__ + "static/Uniteller_Visa_MasterCard_MIR-ad2c24df540ff75ee43f16f76b93a62e.png";